const DESKTOP_COLUMNS = {
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
};

export default function MobileKpiRail({ children, className = "", columns = 4 }) {
  return (
    <div className={`kpi-rail lg:grid ${DESKTOP_COLUMNS[columns] || DESKTOP_COLUMNS[4]} ${className}`}>
      {children}
    </div>
  );
}